import React from 'react';
import {injectIntl} from 'react-intl';
import TooltipContainer from '../forecast-app/shared/components/tooltips/tooltip_container';

const CollapseAll = ({intl: {formatMessage}, toggleCollapse, isCollapsed, userpilot}) => {
	const style = isCollapsed
		? {
				transform: 'rotate( 180deg)',
		  }
		: {};

	return (
		<TooltipContainer tooltipDuration={3000} infoText={isCollapsed ? formatMessage({id: 'workflow.expand'}) : formatMessage({id: 'workflow.collapse'})}>
			<div className={`collapse-all ${isCollapsed ? 'collapsed ' : ''}`} style={style} onClick={toggleCollapse} data-userpilot={userpilot}>
				<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
						<g id="Scheduling---Team-/-Months---Collaborator" transform="translate(-202.000000, -81.000000)" stroke="#535353" strokeWidth="2">
							<g id="Expand-all" transform="translate(182.000000, 64.000000)">
								<g id="Group-4" transform="translate(26.000000, 23.500000) scale(1, -1) translate(-26.000000, -23.500000) translate(21.000000, 19.000000)">
									<polyline id="Path-6" points="0 5.10163038 4.94844237 9 10 5"></polyline>
									<polyline id="Path-6" points="0 0.101630376 4.94844237 4 10 0"></polyline>
								</g>
							</g>
						</g>
					</g>
				</svg>
			</div>
		</TooltipContainer>
	);
};

export default injectIntl(CollapseAll);
